module.exports = __webpack_public_path__ + "img/row1.ee34be61.jpg";